module.exports = __webpack_public_path__ + "static/media/maintain.0c3a8d16.svg";